import { render } from "./ListeOrganisation.vue?vue&type=template&id=70ea1f80&ts=true"
import script from "./ListeOrganisation.vue?vue&type=script&lang=ts"
export * from "./ListeOrganisation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__